var NON_DIGITS_REGEX = /\D/g;
module.exports = {
  NON_DIGITS_REGEX: NON_DIGITS_REGEX
};